import { useTheme } from "styled-components";

import { TableSearch } from "@sso/components/TableSearch";
import { useMediaQuery } from "@sso/hooks/useMediaQuery";
import { TableHeaderActionButton } from "@sso/types";
import { Button } from "@sso/ui/Button";
import { Divider } from "@sso/ui/Divider";
import { ColumnContainer, Flex } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

import { TableHeaderFilters } from "./TableHeaderFilters";
import { TableHeaderPageSize } from "./TableHeaderPageSize";

interface TableHeaderProps {
  title: string;
  TableActions: JSX.Element;
  actionButton?: TableHeaderActionButton;
  hasSearch?: boolean;
}

export const TableHeader = ({ title, TableActions, actionButton, hasSearch = true }: TableHeaderProps) => {
  const theme = useTheme();
  const isMatchedDownSM = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <ColumnContainer width="100%">
      <Flex
        direction={isMatchedDownSM ? "column" : "row"}
        padding={isMatchedDownSM ? "0 0 0.5rem 0" : "0"}
        justify="space-between"
        width="100%"
      >
        <Flex justify="space-between" width="100%" padding="0.5rem 0" wrap={isMatchedDownSM ? "wrap" : "nowrap"}>
          <Typography as="h2" size="1.1rem" fontWeight="bold" padding="0.5rem 1rem" whiteSpace="nowrap">
            {title}
          </Typography>
          {!isMatchedDownSM && hasSearch && <TableSearch />}
          {actionButton && (
            <Flex>
              <Button onClick={actionButton.handleClick} style={{ whiteSpace: "nowrap" }}>
                {actionButton.text}
              </Button>
            </Flex>
          )}
          <Flex margin={isMatchedDownSM ? "0 0 0 auto" : "0"}>
            <TableHeaderPageSize />
            {TableActions}
          </Flex>
        </Flex>
        {isMatchedDownSM && hasSearch && <TableSearch />}
      </Flex>
      <TableHeaderFilters />
      <Divider direction="h" margin="0.5rem 0" />
    </ColumnContainer>
  );
};
